import { useEffect } from 'react';
import { getStateListByCountry } from '../api';
import { codeListMapping } from '../constants';

const useFormOptions = (
  value: string,
  relyBy: { name: string; getByApi: boolean },
  setRelyOnOptions: any
) => {
  const optionChange = async () => {
    if (!relyBy) return;

    let newOptions: any = [];
    const { name, getByApi } = relyBy;

    if (getByApi === true && name === 'state') {
      const stateList = await getStateListByCountry(value);
      if (stateList && stateList.length > 0) {
        newOptions = codeListMapping(stateList);
      }
    }

    setRelyOnOptions && setRelyOnOptions(newOptions);
  };

  optionChange();
};

export default useFormOptions;
